import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import { UpdatePinContentReq } from "interfaces/models/pin";
import { axiosECS } from "services/baseAxios";

const apiPath = `${PATH_API.INSPECTION_PIN}/content`;

export const updatePinContent = async (
  body: UpdatePinContentReq
): Promise<ApiResponse> => {
  return axiosECS.patch(`${apiPath}`, body);
};

export const getContentImageList = async (params: {
  pinId: string;
  itemResultId: string;
  shouldCache?: boolean;
}): Promise<ApiResponse<any[]>> => {
  return axiosECS.get(`${apiPath}/images`, {
    params: { ...params, paging: "cursor" },
  });
};

export const deleteContentImage = async (id: string) => {
  return axiosECS.delete(`${apiPath}/images`, { data: { id } });
};
